import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';

//style
import '../../assets/css/errors.css'

//images
import notFound from '../../assets/images/errors/500.png';

function ServerError() {
    return (
        <main id="errors">
            <div className="wrapper">
                <img src={notFound} alt="error" />
                <h1>
                    Сървърна грешка!
                </h1>
                <p>
                    Екипът на Avtoobuchenie.bg работи по отстраняването на проблема.
                </p>
                <Button>
                    <Link to="/">
                        Начало
                    </Link>
                </Button>
            </div>
        </main>
    )
}

export default ServerError;